/* Mini Dziri — comportements du site. Vanilla, sans dépendance. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
     1. Bandeau de continuité
     Affiche « code déjà appliqué » si le visiteur vient d'une pub
     (utm_source social) ou si une remise est active. Sinon : livraison.
     --------------------------------------------------------------- */
  /* ---------------------------------------------------------------
     1bis. Navigation sur téléphone
     Sous 820 px le menu était masqué sans remplacement : aucune navigation.
     --------------------------------------------------------------- */
  (function navMobile() {
    var btn = document.querySelector('[data-nav-toggle]');
    var nav = document.getElementById('md-site-nav');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () {
      var ouvert = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      btn.setAttribute('aria-label', ouvert ? 'Fermer le menu' : 'Ouvrir le menu');
    });
    // Une navigation interne referme le menu.
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        nav.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  })();

  /* ---------------------------------------------------------------
     2. Son de la vidéo hero
     L'audio EST le produit : autoplay muet, puis activation explicite.
     --------------------------------------------------------------- */
  (function soundToggle() {
    var video = document.getElementById('hero-video');
    var btn = document.querySelector('[data-sound-toggle]');
    if (!video || !btn) return;
    var label = btn.querySelector('[data-sound-label]');

    btn.addEventListener('click', function () {
      video.muted = !video.muted;
      var on = !video.muted;
      btn.setAttribute('aria-pressed', String(on));
      if (label) label.textContent = on ? 'Couper le son' : 'Activer le son';
      if (on && video.paused) video.play().catch(function () {});
    });
  })();

  /* ---------------------------------------------------------------
     3. Sélecteur de packs → prix, bouton, barre collante
     --------------------------------------------------------------- */
  (function packSelector() {
    var radios = document.querySelectorAll('input[name="pack"]');
    if (!radios.length) return;

    function sync() {
      var checked = document.querySelector('input[name="pack"]:checked');
      if (!checked) return;
      var amount = checked.dataset.amount;
      var label = checked.dataset.label;

      document.querySelectorAll('[data-cart-amount]').forEach(function (n) { n.textContent = amount; });
      document.querySelectorAll('[data-sticky-amount]').forEach(function (n) { n.textContent = amount; });
      document.querySelectorAll('[data-sticky-label]').forEach(function (n) { n.textContent = label; });

      // Le bouton de paiement accéléré est un VRAI formulaire produit : sans cette
      // resynchronisation il encaisserait la variante rendue au chargement, pas
      // celle que le client vient de choisir.
      var variantInput = document.querySelector('[data-variant-input]');
      if (variantInput && checked.dataset.variantId) variantInput.value = checked.dataset.variantId;
    }

    radios.forEach(function (r) { r.addEventListener('change', sync); });
    sync();
  })();

  /* ---------------------------------------------------------------
     4. Barre d'achat collante — apparaît après 80 % du hero
     --------------------------------------------------------------- */
  (function stickyBuy() {
    var bar = document.getElementById('sticky-buy');
    var hero = document.querySelector('.md-media') || document.getElementById('product-gallery') || document.querySelector('.packs-app');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { rootMargin: '-20% 0px 0px 0px' }).observe(hero);
  })();

  /* ---------------------------------------------------------------
     5. Boucles vidéo « comment ça marche » — lecture à l'apparition
     preload="none" : rien n'est téléchargé tant que ce n'est pas visible.
     --------------------------------------------------------------- */
  (function lazyLoops() {
    var loops = document.querySelectorAll('.step video');
    if (!loops.length || !('IntersectionObserver' in window)) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.preload === 'none') v.preload = 'auto';
          if (!reduce) v.play().catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.35 });

    loops.forEach(function (v) { io.observe(v); });
  })();

  /* ---------------------------------------------------------------
     6. Échantillonneur audio
     Les fichiers ne sont pas encore enregistrés : on le dit clairement
     plutôt que de simuler un son.
     --------------------------------------------------------------- */
  (function sampler() {
    document.querySelectorAll('[data-audio]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.audio === 'pending') {
          var note = document.querySelector('.sampler-note');
          if (note) note.style.color = 'var(--red)';
          setTimeout(function () { if (note) note.style.color = ''; }, 1200);
          return;
        }
        new Audio(btn.dataset.audio).play().catch(function () {});
      });
    });
  })();

  /* ---------------------------------------------------------------
     7. Carrousel — diaporama mixte photos + vidéos
     La vidéo ne joue que sur la diapositive visible : pas de lecture
     invisible qui consomme de la bande passante.
     --------------------------------------------------------------- */
  (function carousel() {
    document.querySelectorAll('.carousel').forEach(function (root) { setupCarousel(root); });
  })();

  function setupCarousel(root) {
    var view = root.querySelector('.carousel-view');
    if (!view) return;

    var dotsBox = root.querySelector('.car-dots');
    var thumbsBox = root.querySelector('.car-thumbs');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var slides = [], dots = [], thumbs = [], current = 0, io = null;

    function go(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      var target = slides[current].offsetLeft - view.offsetLeft;

      if (reduce) { view.scrollLeft = target; paint(current); return; }

      try { view.scrollTo({ left: target, behavior: 'smooth' }); }
      catch (e) { view.scrollLeft = target; }

      // Filet de sécurité : si l'animation n'aboutit pas (moteur sans
      // défilement animé), on place la vue directement.
      setTimeout(function () {
        if (Math.abs(view.scrollLeft - target) > 4) view.scrollLeft = target;
        paint(current);
      }, 380);
    }

    function paint(i) {
      dots.forEach(function (d, k) { d.setAttribute('aria-current', String(k === i)); });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); });
      slides.forEach(function (s, k) {
        var v = s.querySelector('video');
        if (!v) return;
        if (k === i) { if (v.preload === 'none') v.preload = 'auto'; if (!reduce) v.play().catch(function () {}); }
        else { v.pause(); v.muted = true; syncSoundBtn(s); }
      });
    }

    // Reconstruit la navigation à partir des diapositives présentes.
    // Appelé au chargement, et à chaque changement de pack.
    function build() {
      slides = Array.prototype.slice.call(root.querySelectorAll('.slide'));
      if (dotsBox) dotsBox.innerHTML = '';
      if (thumbsBox) thumbsBox.innerHTML = '';
      if (io) { io.disconnect(); io = null; }
      current = 0;

      dots = !dotsBox ? [] : slides.map(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Aller à la vue ' + (i + 1) + ' sur ' + slides.length);
        b.addEventListener('click', function () { go(i); });
        dotsBox.appendChild(b);
        return b;
      });

      // Miniatures — l'image pour une photo, l'image d'attente pour une vidéo.
      thumbs = !thumbsBox ? [] : slides.map(function (s, i) {
        var img = s.querySelector('img');
        var vid = s.querySelector('video');
        var src = img ? img.getAttribute('src') : (vid ? vid.getAttribute('poster') : '');
        var label = s.getAttribute('aria-label') || ('Vue ' + (i + 1));

        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Voir : ' + label);
        if (src) {
          var im = document.createElement('img');
          im.src = src; im.alt = ''; im.loading = 'lazy';
          b.appendChild(im);
        }
        if (vid) {
          var dot = document.createElement('span');
          dot.className = 'play-dot';
          dot.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5l12 7-12 7z"/></svg>';
          b.appendChild(dot);
        }
        b.addEventListener('click', function () { go(i); });
        thumbsBox.appendChild(b);
        return b;
      });

      if ('IntersectionObserver' in window && slides.length) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && e.intersectionRatio > 0.55) {
              current = slides.indexOf(e.target);
              paint(current);
            }
          });
        }, { root: view, threshold: [0.55, 0.9] });
        slides.forEach(function (s) { io.observe(s); });
      }

      view.scrollLeft = 0;
      paint(0);
    }

    // Boutons et clavier : liés une seule fois, pas à chaque reconstruction.
    if (!root.dataset.bound) {
      root.dataset.bound = '1';
      var prev = root.querySelector('.car-prev');
      var next = root.querySelector('.car-next');
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });

      root.setAttribute('tabindex', '0');
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      });

      // Le son s'active sur la vidéo de la diapositive concernée.
      root.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-sound-toggle]') : null;
        if (!btn) return;
        var slide = btn.closest('.slide');
        var v = slide && slide.querySelector('video');
        if (!v) return;
        v.muted = !v.muted;
        if (!v.muted && v.paused) v.play().catch(function () {});
        syncSoundBtn(slide);
      });
    }

    root.rebuild = build;
    build();
  }

  function syncSoundBtn(slide) {
    var btn = slide.querySelector('[data-sound-toggle]');
    var v = slide.querySelector('video');
    if (!btn || !v) return;
    var on = !v.muted;
    btn.setAttribute('aria-pressed', String(on));
    var label = btn.querySelector('[data-sound-label]');
    if (label) label.textContent = on ? 'Couper le son' : 'Activer le son';
  }

  /* ---------------------------------------------------------------
     8. Visionneuse plein écran — bouton d'agrandissement des vidéos
     --------------------------------------------------------------- */
  (function lightbox() {
    var box = document.getElementById('lightbox');
    if (!box) return;
    var host = box.querySelector('[data-lightbox-media]');
    var lastFocus = null;

    function open(src, poster) {
      lastFocus = document.activeElement;
      host.innerHTML = '';
      var v = document.createElement('video');
      v.src = src;
      if (poster) v.poster = poster;
      v.controls = true;
      v.autoplay = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      host.appendChild(v);
      box.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var c = box.querySelector('.close');
      if (c) c.focus();
    }

    function close() {
      box.classList.remove('is-open');
      host.innerHTML = '';
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.querySelectorAll('[data-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(btn.dataset.zoom, btn.dataset.poster || '');
      });
    });

    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.closest('.close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.classList.contains('is-open')) close();
    });
  })();

  /* ---------------------------------------------------------------
     9. Vignettes du rail vidéo — lecture à l'apparition
     --------------------------------------------------------------- */
  (function railLoops() {
    var vids = document.querySelectorAll('.vidcard video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.preload === 'none') v.preload = 'auto';
          if (!reduce) v.play().catch(function () {});
        } else { v.pause(); }
      });
    }, { threshold: 0.4 });

    vids.forEach(function (v) { io.observe(v); });
  })();

  /* ---------------------------------------------------------------
     10. Panier (maquette) et liste d'attente hors zone
     Aucun envoi réel : à brancher sur Shopify / Klaviyo à l'intégration.
     --------------------------------------------------------------- */
  (function actions() {
    // Deux chemins d'achat sur la même variante : le panier (on continue ses
    // achats) et le paiement direct (on file au checkout). Même requête, seule
    // la destination change.
    // Cadeau : une seule source de vérité (la case + le mot), reflétée dans le
    // formulaire accéléré — champ désactivé = non soumis — et dans les requêtes AJAX.
    var gift = document.querySelector('[data-gift]');
    var giftProp = document.querySelector('[data-gift-prop]');
    var giftMsg = document.querySelector('[data-gift-message]');
    var giftMsgProp = document.querySelector('[data-gift-message-prop]');
    var giftMsgWrap = giftMsg ? giftMsg.closest('.gift-msg') : null;
    var giftCount = document.querySelector('[data-gift-count]');

    function cle(input, defaut) {
      if (!input || !input.name) return defaut;
      return input.name.replace(/^properties\[|\]$/g, '') || defaut;
    }

    function motCadeau() {
      if (!giftMsg || !gift || !gift.checked) return '';
      return giftMsg.value.trim();
    }

    function syncMessage() {
      if (giftCount && giftMsg) {
        giftCount.textContent = giftMsg.value.length;
        var max = parseInt(giftMsg.getAttribute('maxlength'), 10);
        var jauge = giftCount.parentNode;
        if (jauge && max) jauge.classList.toggle('is-max', giftMsg.value.length >= max);
      }
      var texte = motCadeau();
      if (giftMsgProp) {
        giftMsgProp.value = texte;
        giftMsgProp.disabled = !texte;
      }
    }

    function syncGift() {
      var coche = !!(gift && gift.checked);
      if (giftProp) giftProp.disabled = !coche;
      if (giftMsgWrap) {
        giftMsgWrap.hidden = !coche;
        gift.setAttribute('aria-expanded', coche ? 'true' : 'false');
      }
      syncMessage();
    }

    if (gift) {
      gift.addEventListener('change', function () {
        syncGift();
        // On amène le curseur là où il faut écrire, mais seulement sur une
        // action du visiteur — jamais au chargement de la page.
        if (gift.checked && giftMsg) giftMsg.focus();
      });
      syncGift();
    }
    if (giftMsg) giftMsg.addEventListener('input', syncMessage);

    function proprietes() {
      // Une valeur vide n'est jamais envoyée : mieux vaut aucune propriété
      // qu'une ligne « Cadeau: » vide sur la commande.
      if (!gift || !gift.checked) return null;
      var p = null;
      var marque = giftProp ? giftProp.value.trim() : '';
      if (marque) {
        p = p || {};
        p[cle(giftProp, 'Cadeau')] = marque;
      }
      var mot = motCadeau();
      if (mot) {
        p = p || {};
        p[cle(giftMsgProp, 'Message')] = mot;
      }
      return p;
    }

    function acheter(btn, destination) {
      var checked = document.querySelector('input[name="pack"]:checked');
      var label = checked ? checked.dataset.label : '';
      var amount = checked ? checked.dataset.amount : '';
      var variantId = checked && checked.dataset.variantId;

      if (!variantId) {
        alert('Maquette — à brancher sur le panier Shopify.\n\n' + label + ' · ' + amount);
        return;
      }
      if (btn.getAttribute('aria-busy') === 'true') return; // anti double-clic
      btn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify((function () {
          var charge = { id: Number(variantId), quantity: 1 };
          var props = proprietes();
          if (props) charge.properties = props;
          return charge;
        })())
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        window.location.href = destination;
      }).catch(function () {
        btn.removeAttribute('aria-busy');
        alert("L'ajout au panier a échoué — réessayez.");
      });
    }

    // Un formulaire produit réel signifie que la boutique gère les lots
    // (Bundler) : l'ajout au panier doit rester une soumission normale, sinon
    // la remise ne s'applique pas. On n'accroche donc rien dans ce cas.
    var formProduit = document.getElementById('md-product-form');
    if (!formProduit) {
      document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
        btn.addEventListener('click', function () { acheter(btn, '/cart'); });
      });
    }
    if (!formProduit) {
      document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
        btn.addEventListener('click', function () { acheter(btn, '/checkout'); });
      });
    }

    // Mode application : les deux boutons soumettent le MÊME formulaire (sinon
    // la remise sur les lots ne s'applique pas). Seule la destination change,
    // via le champ return_to que Shopify lit après /cart/add.
    var retour = document.querySelector('[data-return-to]');
    document.querySelectorAll('[data-buy-now-form]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (retour) retour.value = '/cart?relais=1';
      });
    });
    document.querySelectorAll('[data-add-to-cart], button[name="add"]:not([data-buy-now-form])').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (retour) retour.value = '/cart';
      });
    });

    var form = document.querySelector('[data-waitlist]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var msg = document.querySelector('[data-waitlist-msg]');
      var pays = form.querySelector('select').value;
      if (msg) {
        msg.textContent = 'Merci — nous vous préviendrons dès que nous livrerons en ' + pays +
                          '. (Maquette : à brancher sur Klaviyo, avec le pays en étiquette.)';
        msg.style.color = 'var(--forest)';
      }
      form.reset();
    });
  })();
})();

  /* ---------------------------------------------------------------
     11. Galerie produit liée au pack choisi
     Chaque pack raconte son usage : le kit montre l'objet, le duo
     montre la transmission, le trio montre la famille.
     RÈGLE : la première vue est toujours une PHOTO du produit,
     jamais une vidéo — on montre ce qu'on achète avant de le démontrer.
     --------------------------------------------------------------- */
  (function packGallery() {
    var root = document.querySelector('[data-pack-gallery]');
    if (!root) return;
    var view = root.querySelector('.carousel-view');
    var note = root.querySelector('[data-gallery-note]');

    var IMG = 'assets/img/', VID = 'assets/video/';

    // Sur Shopify, la configuration vient du JSON emis par la section Liquid
    // (blocs de l'editeur). Le litteral ci-dessous n'est que le repli maquette.
    var GALLERIES = {
      kit: {
        qty: 1,
        note: 'Un coffret : le boîtier, 112 cartes et le câble USB.',
        items: [
          { img: IMG + 'photo-boitier-carte.webp', tag: 'Le coffret', alt: 'Le boîtier Mini Dziri avec une carte illustrée' },
          { vid: VID + 'demo-kids.mp4', poster: IMG + 'demo-kids-poster.webp', tag: 'Il insère la carte, le mot est prononcé', alt: 'Un enfant glisse une carte dans le boîtier' },
          { img: IMG + 'photo-produit-cartes.webp', tag: '112 cartes · 224 mots', alt: 'Les cartes avec la translittération latine' },
          { vid: VID + 'demo-girl.mp4', poster: IMG + 'demo-girl-poster.webp', tag: 'Sans écran, il reste concentré', alt: 'Une enfant fait prononcer un mot en darija' },
          { img: IMG + 'pack-outbox-face.webp', tag: 'Le nouveau coffret illustré', alt: 'La boîte Mini Dziri illustrée : le fennec, le Mémorial du Martyr et la carte de l\'Algérie' },
          { img: IMG + 'cartes-themes.webp', tag: 'Les cartes, classées par thème', alt: 'Un éventail de cartes Mini Dziri classées par thème : fruits, corps, chiffres, politesse' }
        ]
      },
      duo: {
        qty: 2,
        note: 'Deux coffrets : un à la maison, un chez les grands-parents.',
        items: [
          { img: IMG + 'photo-produit-cartes.webp', tag: 'Le coffret', alt: 'Le boîtier, la boîte et les cartes illustrées' },
          { img: IMG + 'hero-mamie.webp', tag: 'Un chez les grands-parents', alt: 'Une grand-mère et son petit-fils jouent ensemble' },
          { vid: VID + 'demo-duo.mp4', poster: IMG + 'demo-duo-poster.webp', tag: 'La langue circule entre les générations', alt: 'Un enfant montre le boîtier' },
          { img: IMG + 'photo-boite-fennec.webp', tag: 'Prêt à offrir', alt: 'La boîte Mini Dziri et son contenu' },
          { img: IMG + 'pack-passeport.webp', tag: 'Format passeport, prêt à offrir', alt: 'Le coffret Mini Dziri façon passeport linguistique, posé sur une table' }
        ]
      },
      trio: {
        qty: 3,
        note: 'Trois coffrets : fratrie, cousins, ou un à offrir.',
        items: [
          { img: IMG + 'photo-boite-fennec.webp', tag: 'Le coffret', alt: 'La boîte Mini Dziri et son contenu' },
          { img: IMG + 'hero-mamie.webp', tag: 'Toute la famille s\'y met', alt: 'Une grand-mère et son petit-fils jouent ensemble' },
          { vid: VID + 'demo-duo.mp4', poster: IMG + 'demo-duo-poster.webp', tag: 'Chacun le sien', alt: 'Un enfant utilise le boîtier' },
          { img: IMG + 'photo-enfant-boitier.webp', tag: 'En autonomie', alt: 'Un enfant tient le boîtier et écoute un mot' },
          { vid: VID + 'demo-girl.mp4', poster: IMG + 'demo-girl-poster.webp', tag: 'Sans écran', alt: 'Une enfant fait prononcer un mot en darija' },
          { img: IMG + 'pack-outbox-equipe.webp', tag: 'Toute l\'équipe t\'accompagne', alt: 'Le dos de la boîte Mini Dziri : le fennec, les enfants et les animaux du jeu réunis' }
        ]
      }
    };

    var cfgEl = document.querySelector('script[data-pack-galleries]');
    if (cfgEl) { try { GALLERIES = JSON.parse(cfgEl.textContent); } catch (e) { /* repli maquette */ } }

    var SOUND_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M19 5a9 9 0 0 1 0 14"/></svg>';

    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    function render(key) {
      var g = GALLERIES[key] || GALLERIES.duo;
      var n = g.items.length;

      view.innerHTML = g.items.map(function (it, i) {
        var label = (i + 1) + ' sur ' + n + ' — ' + it.tag;
        var media = it.vid
          ? '<video src="' + it.vid + '" poster="' + it.poster + '" muted loop playsinline preload="' + (i < 2 ? 'metadata' : 'none') + '" aria-label="' + esc(it.alt) + '"></video>'
            + '<button class="sound-btn" type="button" data-sound-toggle aria-pressed="false">' + SOUND_ICON + '<span data-sound-label>Activer le son</span></button>'
          : '<img src="' + it.img + '" alt="' + esc(it.alt) + '" loading="' + (i === 0 ? 'eager' : 'lazy') + '">';
        // qty à 0 = pas de lot côté thème (l'application gère les lots) : pas de badge.
        var badge = (i === 0 && g.qty)
          ? '<span class="qty-badge">\u00d7' + g.qty + ' <small>' + (g.qty > 1 ? 'coffrets' : 'coffret') + '</small></span>'
          : '';
        return '<div class="slide' + (it.vid ? ' slide--portrait' : '') + '" role="group" aria-label="' + esc(label) + '">'
             + badge + '<span class="slide-tag">' + esc(it.tag) + '</span>' + media + '</div>';
      }).join('');

      if (note) note.textContent = g.note;
      if (typeof root.rebuild === 'function') root.rebuild();
      else setupCarousel(root);
    }

    // Deux mecaniques de packs coexistent : les radios de la maquette
    // (name="pack", valeurs kit/duo/trio) et celles de l'application Bundler
    // (name="bundle_quantity", valeurs 1/2/3). On lit les deux, et on relie la
    // quantite a la cle de galerie par le champ qty deja present dans le JSON,
    // plutot que de coder la correspondance en dur.
    var CLES = Object.keys(GALLERIES);

    function cleParQuantite(q) {
      for (var i = 0; i < CLES.length; i++) {
        if (String(GALLERIES[CLES[i]].qty) === String(q)) return CLES[i];
      }
      // Repli sur l'ordre des cles : une quantite mal renseignee dans l'editeur
      // ne doit pas figer la galerie sur un pack.
      var n = parseInt(q, 10);
      if (n >= 1 && n <= CLES.length) return CLES[n - 1];
      return null;
    }

    function current() {
      var c = document.querySelector('input[name="pack"]:checked');
      if (c && GALLERIES[c.value]) return c.value;
      var b = document.querySelector('input[name="bundle_quantity"]:checked');
      if (b) {
        var k = cleParQuantite(b.value);
        if (k) return k;
      }
      return CLES[0];
    }

    // Delegation sur le document : Bundler reconstruit son formulaire apres
    // notre initialisation, des ecouteurs poses sur ses radios seraient perdus.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'INPUT') return;
      if (t.name === 'pack' || t.name === 'bundle_quantity') render(current());
    });
    // Filet : l'application annonce son changement de lot par cet evenement.
    document.addEventListener('bndlr:quantity_break:price_update', function () { render(current()); });

    render(current());
  })();


  /* ---------------------------------------------------------------
     13. Bundler — francisation des libellés et report du lot choisi
     L'application rend « 1 KIT » et « Save 6.90€! » (textes saisis dans son
     back-office, partagés avec la boutique en ligne : les changer là-bas
     toucherait le site en production). On les réécrit donc à l'affichage.
     Au passage, on inscrit le lot choisi dans une propriété de commande :
     sans elle, la commande ne dit que « quantité 3 », jamais « le trio ».
     --------------------------------------------------------------- */
  (function bundlerPack() {
    var zone = document.getElementById('packs');
    if (!zone) return;
    var cfgEl = document.querySelector('script[data-bundler-cfg]');
    if (!cfgEl) return;
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var prop = document.querySelector('[data-pack-prop]');

    function libelle(n) {
      return n > 1 ? String(cfg.plusieurs || '{n}').replace('{n}', n)
                   : (cfg.un || String(n));
    }

    // « Save 6.90€! » / « 6.90 € » → « 6,90 € » puis dans le gabarit d'économie.
    function economie(brut) {
      var m = String(brut).replace(/\u00a0/g, ' ').match(/(\d+(?:[.,]\d{1,2})?)/);
      if (!m) return null;
      var montant = m[1].replace('.', ',');
      if (montant.indexOf(',') === -1) montant += ',00';
      return String(cfg.economie || '{p}').replace('{p}', montant + '\u00a0\u20ac');
    }

    function quantite(conteneur) {
      var r = conteneur.querySelector('input[type="radio"][name="bundle_quantity"]');
      return r ? parseInt(r.value, 10) : null;
    }

    function traduire() {
      zone.querySelectorAll('.bndlr-radio-container').forEach(function (c) {
        var n = quantite(c);
        if (!n) return;
        if (cfg.franciser) {
          var t = c.querySelector('.bndlr-text');
          if (t && t.textContent.trim() !== libelle(n)) t.textContent = libelle(n);
          var e = c.querySelector('.bndlr-savings-text');
          if (e) {
            var fr = economie(e.textContent);
            if (fr && e.textContent.trim() !== fr) e.textContent = fr;
          }
        }
      });
    }

    function reporterPack() {
      if (!prop) return;
      var actif = zone.querySelector('.bndlr-radio-container[data-bundler-break-active="true"]')
               || zone.querySelector('input[name="bundle_quantity"]:checked');
      var n = actif ? quantite(actif.closest ? (actif.closest('.bndlr-radio-container') || actif) : actif) : null;
      if (!n && actif && actif.value) n = parseInt(actif.value, 10);
      if (n) { prop.value = libelle(n); prop.disabled = false; }
      else   { prop.value = ''; prop.disabled = true; }
    }

    // La barre d'achat collante affichait un prix figé : on la synchronise
    // sur le lot actif (libellé francisé + prix remisé).
    function majSticky() {
      var actif = zone.querySelector('.bndlr-radio-container[data-bundler-break-active="true"]');
      if (!actif) return;
      var n = quantite(actif);
      var prix = actif.querySelector('.bndlr-discounted-price') || actif.querySelector('.bndlr-price');
      var lbl = document.querySelector('[data-sticky-label]');
      var amt = document.querySelector('[data-sticky-amount]');
      if (lbl && n) lbl.textContent = libelle(n);
      if (amt && prix) amt.textContent = prix.textContent.trim();
    }

    // L'app met tabindex="0" sur le conteneur alors que la vraie commande est
    // la case : on rend la tabulation unique et prévisible.
    function clavier() {
      zone.querySelectorAll('.bndlr-radio-container[tabindex]').forEach(function (c) {
        c.setAttribute('tabindex', '-1');
      });
    }

    // La fenêtre « You got … OFF » de l'app est en anglais : on la traduit à
    // l'affichage, comme les libellés de lots.
    function traduireFenetre() {
      if (!cfg.franciser) return;
      var f = document.getElementById('bndlr-discount-message');
      if (!f || f.dataset.mdFr) return;
      var map = [
        ['You got', 'Vous avez'],
        ['OFF your order', 'de remise'],
        ['Apply discount and go to checkout?', 'Appliquer la remise et passer au paiement ?'],
        ['Yes, please', 'Oui'],
        ['No', 'Non']
      ];
      var it = document.createNodeIterator(f, NodeFilter.SHOW_TEXT);
      var t;
      while ((t = it.nextNode())) {
        map.forEach(function (m) { t.nodeValue = t.nodeValue.replace(m[0], m[1]); });
      }
      f.dataset.mdFr = '1';
    }

    function passe() { traduire(); reporterPack(); majSticky(); clavier(); }


    // L'application injecte son widget après coup, puis le remanie à chaque
    // clic : on observe plutôt que de parier sur un instant précis.
    new MutationObserver(passe).observe(zone, { childList: true, subtree: true });
    // la fenêtre de remise apparaît n'importe où dans la page
    new MutationObserver(traduireFenetre).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('bndlr:quantity_break:price_update', passe);
    zone.addEventListener('change', passe);
    zone.addEventListener('click', function () { setTimeout(passe, 60); });
    passe();
  })();

  /* ---------------------------------------------------------------
     12. Parlyo — garde anti-recouvrement
     Le widget est le vrai produit, posé en une ligne dans
     snippets/md-parlyo.liquid. Son nom, son avatar, sa voix, ses
     suggestions et ses réponses viennent du tableau de bord Parlyo :
     on ne redessine rien et on ne style pas son intérieur.

     Une seule chose nous revient : son lanceur est en position fixe et
     finit par passer au-dessus du bouton d'achat, où il intercepte le
     clic. Mesuré sur le widget en ligne : le conteneur div[data-parlyo]
     fait 0x0 — les éléments visibles (bulle, satellite micro, teaser)
     sont en position fixe DANS son shadow root ouvert. On mesure donc
     ceux-là, et on efface le conteneur : visibility et pointer-events
     sont hérités jusque dans le shadow — vérifié en ligne, la bulle
     passe à hidden/none et le clic retombe sur la page, tout en restant
     mesurable pour que la garde puisse la rendre.
     --------------------------------------------------------------- */
  (function parlyoGarde() {
    var SEL_CTA = '.md-buy-form button[name="add"], .buy-stack button, .sticky-buy button, .sticky-buy a';
    var hote = null;

    // Les boîtes qui comptent sont dans le shadow root, pas sur l'hôte.
    // On les repère par leur position, jamais par leur classe : les noms
    // internes du widget ne nous appartiennent pas et peuvent changer.
    function boitesDuWidget() {
      var sr = hote.shadowRoot;
      if (!sr) return [];
      var out = [];
      var noeuds = sr.querySelectorAll('*');
      for (var i = 0; i < noeuds.length; i++) {
        var cs = window.getComputedStyle(noeuds[i]);
        if (cs.position !== 'fixed' || cs.display === 'none') continue;
        var r = noeuds[i].getBoundingClientRect();
        if (r.width && r.height) out.push(r);
      }
      return out;
    }

    function verifier() {
      if (!hote || hote.isConnected === false) return;
      var boites = boitesDuWidget();
      if (!boites.length) return;
      // Panneau ouvert : une boîte devient haute. On n'efface jamais dans cet
      // état, sinon la conversation en cours disparaîtrait sous les doigts.
      for (var i = 0; i < boites.length; i++) {
        if (boites[i].height > 200) { hote.classList.remove('parlyo-efface'); return; }
      }
      var marge = 8;
      var conflit = [].slice.call(document.querySelectorAll(SEL_CTA)).some(function (c) {
        var r = c.getBoundingClientRect();
        if (!r.width || !r.height) return false;
        return boites.some(function (l) {
          return r.left < l.right + marge && r.right > l.left - marge &&
                 r.top < l.bottom + marge && r.bottom > l.top - marge;
        });
      });
      hote.classList.toggle('parlyo-efface', conflit);
    }

    // Deux mécanismes, parce qu'un seul ne suffit pas :
    //
    //  - un ÉTRANGLEMENT, pour rester réactif pendant qu'on fait défiler sans
    //    mesurer à chaque image ; par horodatage et non par verrou booléen, un
    //    verrou qui attend requestAnimationFrame restant coincé quand l'onglet
    //    passe en arrière-plan ;
    //  - un CONTRÔLE APRÈS LA SALVE, parce que le navigateur peut ne dispatcher
    //    qu'UN SEUL événement pour tout un défilement animé, et l'envoyer au
    //    DÉBUT du mouvement. Mesuré le 06/09 sur « theme dev » : un aller-retour
    //    à la molette ne produit qu'un événement, émis alors que le bouton
    //    d'achat recouvre encore le lanceur — sans ce second contrôle, le
    //    lanceur restait effacé une fois revenu en haut de page.
    var dernier = 0;
    var minuteur = null;
    function verifierApres(ms) {
      if (minuteur) clearTimeout(minuteur);
      minuteur = setTimeout(function () {
        minuteur = null;
        dernier = Date.now();
        verifier();
      }, ms);
    }
    function planifier() {
      var t = Date.now();
      if (t - dernier >= 80) {
        dernier = t;
        verifier();
      }
      verifierApres(160);
    }

    function brancher(el) {
      hote = el;
      window.addEventListener('scroll', planifier, { passive: true });
      window.addEventListener('resize', planifier, { passive: true });
      window.addEventListener('pageshow', verifier);
      document.addEventListener('visibilitychange', verifier);
      // Le widget ouvre et ferme son panneau sans prévenir la page : on
      // observe son shadow root plutôt que de parier sur un événement.
      if (el.shadowRoot && window.MutationObserver) {
        new MutationObserver(planifier).observe(el.shadowRoot, {
          childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style']
        });
      }
      verifier();
    }

    // Le script est chargé en async puis attend sa configuration : le
    // conteneur n'existe pas encore quand ce module s'exécute.
    var deja = document.querySelector('div[data-parlyo]');
    if (deja) { brancher(deja); return; }
    if (!window.MutationObserver) return;
    var guet = new MutationObserver(function () {
      var el = document.querySelector('div[data-parlyo]');
      if (!el) return;
      guet.disconnect();
      brancher(el);
    });
    guet.observe(document.documentElement, { childList: true, subtree: true });
  })();

  /* ---------------------------------------------------------------
     14. Fenêtre d'inscription — ouverture différée, une fois par session
     Le pop-up de Flora n'avait ni rôle de dialogue, ni Échap, ni piège de
     focus, et n'était jamais rouvrable une fois la clé posée. Ici : la clé
     n'est écrite QU'À la fermeture, le focus est capturé puis rendu, et
     l'ouverture est annulée si le visiteur a déjà quitté la page.
     --------------------------------------------------------------- */
  (function fenetreInscription() {
    var pop = document.querySelector('[data-md-pop]');
    if (!pop) return;

    var CLE = 'md-pop-vue';
    var revient = location.search.indexOf('customer_posted=true') !== -1;
    try { if (!revient && sessionStorage.getItem(CLE)) return; } catch (e) { /* mode privé */ }

    var boite = pop.querySelector('.md-pop__boite');
    var avant = null;
    var minuteur = null;

    function focusables() {
      return [].slice.call(boite.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )).filter(function (el) { return !el.disabled && el.offsetParent !== null; });
    }

    function ouvrir() {
      avant = document.activeElement;
      pop.hidden = false;
      // laisse un cadre au navigateur pour que la transition parte de son état initial
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      var f = focusables();
      if (f.length) f[0].focus();
    }

    function fermer() {
      try { sessionStorage.setItem(CLE, '1'); } catch (e) { /* mode privé */ }
      pop.classList.remove('is-open');
      pop.hidden = true;
      document.body.style.overflow = '';
      if (avant && avant.focus) avant.focus();
    }

    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-md-pop-fermer]')) fermer();
    });

    document.addEventListener('keydown', function (e) {
      if (pop.hidden) return;
      if (e.key === 'Escape') { fermer(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var premier = f[0], dernier = f[f.length - 1];
      if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
    });

    // La bannière de consentement Shopify est en z-index 2000000 : elle recouvre la
    // fenêtre, et sur téléphone le formulaire devient inatteignable. On ne passe PAS
    // au-dessus d'elle — cacher le choix du visiteur serait pire que d'attendre. On
    // patiente donc jusqu'à ce qu'il ait répondu, puis on ouvre.
    function consentementAffiche() {
      var el = document.getElementById('shopify-pc__banner');
      if (!el) return false;
      // « offsetParent » vaut TOUJOURS null sur un élément position:fixed — la bannière
      // en est un. Le tester ici rendait la garde inopérante. On mesure la boîte.
      return el.getBoundingClientRect().height > 0;
    }

    function ouvrirQuandLibre(restant) {
      if (!consentementAffiche()) { ouvrir(); return; }
      if (restant <= 0) return;                    // le visiteur n'a pas tranché : on renonce
      minuteur = setTimeout(function () { ouvrirQuandLibre(restant - 1); }, 800);
    }

    // Retour d'un envoi réussi : on montre le remerciement tout de suite, sans délai,
    // et la session est marquée pour que la fenêtre ne revienne plus.
    if (revient) {
      try { sessionStorage.setItem(CLE, '1'); } catch (e) { /* mode privé */ }
      ouvrir();
      return;
    }

    var delai = parseInt(pop.dataset.delai, 10);
    if (isNaN(delai) || delai < 0) delai = 5;
    minuteur = setTimeout(function () { ouvrirQuandLibre(75); }, delai * 1000);
    // une page quittée avant l'ouverture ne doit pas rouvrir au retour arrière
    window.addEventListener('pagehide', function () { clearTimeout(minuteur); });
  })();
